import * as sizes from './style.module.css';
export const typeSizes = {
    micro: sizes.micro,
    mini: sizes.mini,
    small: sizes.small,
    body: sizes.body,
    large: sizes.large,
    hero: sizes.hero,
    title1: sizes.title1,
    title2: sizes.title2,
    title3: sizes.title3,
};
export default typeSizes;
//# sourceMappingURL=typeSizes.js.map